$(() => {
  const $moreInfoHeader = document.querySelector('.service__section--more-information .service__header');
  const $smoreInfoTxt = document.querySelector('.service__section--more-information .service__text');
  const $smoreInfoImg = document.querySelector('.service__section--more-information .service__img');
  const $moreInfoForm = document.querySelector('.service__section--more-information .service__form');

  if ($moreInfoForm) {
    $moreInfoHeader.classList.add('service__content--flex');
    $smoreInfoTxt.classList.add('service__text--half-width');
    $smoreInfoImg.classList.add('service__img--half-width');
  }

  const $serviceListContent = document.querySelector('.service__section--services-list .service__content');
  const $serviceBlock = document.querySelector('.service__section--services-list .service__block--1');

  if ($serviceBlock) {
    $serviceListContent.classList.add('service__content--flex');
  }

  // eslint-disable-next-line prettier/prettier
  const $contactTemplateWrapper =
    document.querySelector('.content__main--template-contact .contact__content') || document.querySelector('.service__section--more-information .service__content');
  const $contactForm = document.querySelector('.content__main--template-contact .contact__form') || document.querySelector('.content__main--template-services .service__form');

  if ($contactForm) {
    const contactFormHeight = $contactForm.clientHeight;
    $contactTemplateWrapper.style.minHeight = contactFormHeight + 'px';
  }

  const $auctionCarousel = document.querySelector('.event-details .carousel');

  if ($auctionCarousel) {
    const $innerCarousel = $auctionCarousel.querySelector('.carousel-inner');
    const $carouselPrevArrow = $auctionCarousel.querySelector('.carousel-control-prev');
    const $carouselNextArrow = $auctionCarousel.querySelector('.carousel-control-next');
    $innerCarousel.appendChild($carouselNextArrow);
    $innerCarousel.appendChild($carouselPrevArrow);
  }
});
